import { useState, useEffect } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "../components/ui/dialog";
import { Button } from "../components/ui/button";
import { AlertTriangle, Calendar, Upload } from "lucide-react";

const ReminderPopup = ({ onGoToUpload }) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    checkReminder();
  }, []);

  const checkReminder = () => {
    const today = new Date();
    const dayOfMonth = today.getDate();
    
    // Show reminder from day 10 onwards
    if (dayOfMonth >= 10) {
      // Check if already dismissed today
      const lastDismissed = localStorage.getItem("reminderDismissedDate");
      const todayStr = today.toISOString().split("T")[0];
      
      if (lastDismissed !== todayStr) {
        setIsOpen(true);
      }
    }
  };

  const handleDismiss = () => {
    const todayStr = new Date().toISOString().split("T")[0];
    localStorage.setItem("reminderDismissedDate", todayStr);
    setIsOpen(false);
  };

  const handleGoToUpload = () => {
    handleDismiss();
    if (onGoToUpload) {
      onGoToUpload();
    }
  };

  const currentMonth = new Date().toLocaleDateString("it-IT", { month: "long", year: "numeric" });

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent className="bg-[#0A0A0A] border border-[#D4AF37]/30 max-w-md">
        <DialogHeader>
          <div className="flex items-center gap-3 mb-2">
            <div className="w-12 h-12 rounded-full bg-[#D4AF37]/10 flex items-center justify-center">
              <AlertTriangle className="w-6 h-6 text-[#D4AF37]" />
            </div>
            <DialogTitle className="text-xl font-serif text-[#EDEDED]">
              Promemoria Documenti
            </DialogTitle>
          </div>
          <DialogDescription className="text-[#A1A1AA] pt-2">
            <div className="flex items-center gap-2 mb-3">
              <Calendar className="w-4 h-4 text-[#D4AF37]" />
              <span className="capitalize">{currentMonth}</span>
            </div>
            <p>
              È il momento di caricare i documenti del mese! Assicurati di aver caricato:
            </p>
            <ul className="mt-3 space-y-1 text-sm text-[#A1A1AA]">
              <li>• Fatture Estere</li>
              <li>• Estratti Conto e Carte di Credito</li>
              <li>• Paghe e RIBA</li>
              <li>• Commissioni POS e altre ricevute</li>
            </ul>
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="mt-6 flex gap-2">
          <Button
            variant="ghost"
            onClick={handleDismiss}
            className="text-[#A1A1AA] hover:text-[#EDEDED]"
            data-testid="reminder-dismiss-btn"
          >
            Ricordamelo dopo
          </Button>
          <Button
            onClick={handleGoToUpload}
            className="bg-[#D4AF37] text-black hover:bg-[#B5952F]"
            data-testid="reminder-upload-btn"
          >
            <Upload className="w-4 h-4 mr-2" />
            Carica Documenti
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ReminderPopup;
